module.exports = __webpack_public_path__ + "img/xuChang.f43049c4.jpg";